import * as PropTypes from "prop-types";
import { useDemo } from "contexts/DemoContext";
import { Typography } from "components/typography";
import CONSTANTS from "core/constants";

/**
 * @deprecated Use **`Typography`** component under `src/components`.
 */
const Text = ({
  style,
  value,
  sensitiveField = false,
  className = {},
  variant = "body",
}) => {
  const demo = useDemo();
  const text = value && sensitiveField && demo ? CONSTANTS.DEMO : value;
  return (
    <Typography style={style} className={className} variant={variant}>
      {text || ""}
    </Typography>
  );
};

Text.propTypes = {
  className: PropTypes.string,
  sensitiveField: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.any,
  variant: PropTypes.string,
};

export default Text;
